import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DiscountCouponService from "./Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import Select from 'react-select';
import { Col, CardBody, Card } from "reactstrap";
import PermissionAccess from '../../PermissionAccess/Access.js';

const AddDiscountCouponModal = ({ showModalAddDiscountCoupon, handleToggleModalAddDiscountCoupon, onSuccess }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [data, setData] = useState({
    name: '',
    quantity_id: '',
  });


  const [errors, setErrors] = useState({
    name: '',
    quantity_id: '',
  });

  const [measurements, setMeasurements] = useState([]);

  const fetchMeasurements = () => {
    setLoading(true);
    DiscountCouponService.getAllQuantities(authData.sessionID, 0, 9999999, '', '', true)
      .then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          setMeasurements(response.data.data.map(item => ({
            value: item._id,
            label: item.name
          })));
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(error.message || t("Server Error, Please try again later."));
      });
  };
  

  useEffect(() => {
    fetchMeasurements();
  }, []);


  const handleChange = (e) => {
    const { name,quantity_id, value } = e.target || e;
    let error = '';
  
      // Handle other fields as before
      if (name === 'name' && !value) {
        error = 'Dose is required';
      }
      if (name === 'quantity_id' && !value) {
        error = 'Measurement is required';
      }  
      setData(prevData => ({ ...prevData, [name]: value }));
    
  
    setErrors(prevErrors => ({ ...prevErrors, [name]: error }));
  };
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!data.name) { validationErrors.name = 'Dose is required'; }
    if (!data.quantity_id) { validationErrors.quantity_id = 'Measurement is required'; }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      DiscountCouponService.AddDose(authData.sessionID,data).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          if (response.data.status === true) {
            resetForm();
            handleToggleModalAddDiscountCoupon();
            onSuccess();
            validationErrors.name = '';
            Alerts.swalSuccessAlert(t("Dose added successfully."));
          } else {
            validationErrors.name = response.data.errors[0].message || 'An error occurred';
            setErrors(validationErrors);
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
    }
  };

  const resetForm = () => {
    setData({
      name: '',
      quantity_id: '',
    });
  };

  const handleClose = () => {
    setErrors({
        name: '',
        quantity_id: '',
    });
    handleToggleModalAddDiscountCoupon();
  };

  return (
    <div className={showModalAddDiscountCoupon ? "modal d-block mt-4" : "modal"} style={{ display: showModalAddDiscountCoupon ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1" role="dialog">
      <form onSubmit={handleSubmit}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{t("Add Dose")}</h5>
            </div>
            <div className="modal-body">
            <Col md="12">
                <Card className="main-card mb-3">
                     <CardBody>
              <LoadingOverlay
                tag="div"
                active={loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}
              >
                <input type="hidden" className="form-control" name="business_id" />

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="coupon-code" className="col-form-label">{t("Dose")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Dose" 
                      name="name"
                      onChange={handleChange}
                      value={data.name}
                      />
                      {errors.name && <strong className="error text-danger">{errors.name}</strong>}
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="status-select" className="col-form-label">{t("Measurement")}:</label>
                      <select 
                        className="form-control"
                        name="quantity_id"
                        onChange={handleChange}
                        value={data.quantity_id}
                        >
                        <option value="">{t("Select Measurement")}</option>
                        {measurements.map((measurement) => (
                            <option key={measurement.value} value={measurement.value}>
                            {measurement.label}
                            </option>
                        ))}
                    </select>
                      {errors.quantity_id && <strong className="error text-danger">{errors.quantity_id}</strong>}
                    </div>
                  </div>


                

                <div className="row">
                 
                  
                  <div className="text-center mt-4">
                  <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleClose}>{t("Close")}</button>
                  <button type="submit" className="btn btn-custom-color">{t("Save")}</button>
                </div>
                </div>
                                          </LoadingOverlay>
                                        </CardBody>
                                    </Card>
                                </Col>
            </div>
            
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddDiscountCouponModal;

